// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
import VueI18n from 'vue-i18n'
import share from './utils/share'
import titleMixin from './utils/title'

import VueDateFns from "vue-date-fns"
import visibility from 'vue-visibility-change'

import VueIntro from 'vue-introjs'

// import ActionCable from 'actioncable'

// let protocol = 'ws';
// if (process.env.BASE_PROTOCOL === 'https') {
//   protocol = 'wss';
// }
// const cable = ActionCable.createConsumer(`${protocol}:${process.env.BASE_ADDRESS}/cable`);
// Vue.prototype.$cable = cable;

Vue.config.productionTip = false

const langs = require('./languages.json')

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja',
  messages: langs
})
Vue.mixin(titleMixin)

Vue.use(visibility)
Vue.use(VueDateFns)
Vue.use(VueIntro)
Vue.use(ElementUI, { locale })
Vue.mixin(share)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
